module.exports = __webpack_public_path__ + "static/media/programming-svgrepo-com.60295f0f.svg";